export default "__VITE_ASSET__BuS7FEFj__"